<template>
<v-dialog v-model="dialog" max-width="50vw">
  <v-card>
    <v-card-title class="text-h5 bg-primary-lighten-1 d-flex justify-space-between align-center" primary-title>
      <div>
        <v-icon size="large" style="color: white" class="pr-3">
            mdi-clock-outline
        </v-icon>
        <span style="color: white">
          {{ title }}
        </span>
      </div>
      <Button class="close-button" large icon @click="closeDialog">
          <v-icon color="white">
              mdi-close
          </v-icon>
      </Button>
    </v-card-title>

    <div align="center" class="pt-4">
          <v-date-picker
          color="primary"
          elevation="10"
          v-model="selectedDate"
          reactive
          scrollable
          :allowed-dates="forbidFutureDates ? allowedDates : (date) => {return date}">
        </v-date-picker>
    </div>

    <v-card-actions>
        <v-spacer></v-spacer>
        <Button variant="flat" color="error" @click="deleteDate" :disabled="!reset || notNullable">
            Datum zurücksetzen
        </Button>
        <Button variant="flat" color="primary" @click="emitDate" :disabled="this.selectedDate === null">
            Speichern
        </Button>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>
import Button from '@s/views/general_components/components/Button'
import { firstLetterUpperCase } from '@s/util/helper'

export default {
    name: "datepicker-dialog",
    components: {
      Button
    },
    props: {
      forbidFutureDates: {
        type: Boolean,
        default: false
      },
      notNullable: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
            dialog: false,
            selectedDate: null,
            key: null,
            title: '',
            pickerDate: null,
            reset: false,
            newSelectedDate: [],
        }
    },
    methods: {
        open(title, key, date) {
          if(date !== null){
            date = new Date(date);
            this.reset = true;
          } else {
            date = new Date();
          }
          this.title = title;
          this.key = key;
          this.selectedDate = date;
          this.dialog = true;
        },
        closeDialog() {
          this.title = '';
          this.key = null;
          this.selectedDate = null;
          this.reset = false;
          this.dialog = false;
        },
        emitDate(){
          const userTimezoneOffset = this.selectedDate ? this.selectedDate.getTimezoneOffset() * 60000 : 0;
          const correctedDate = this.selectedDate ? new Date(this.selectedDate.getTime() - userTimezoneOffset).toISOString().split('T')[0] : null;
          this.$emit('emitDate', this.key, correctedDate);
          this.closeDialog();
        },
        deleteDate(){
          this.selectedDate = null;
          this.$emit('emitDate', this.key, null);
          this.closeDialog();
        },
        allowedDates(val){
          const today = new Date();
          const seconds = today.getTime() / 1000;
          const date = new Date(val);
          const dateSeconds = date.getTime() / 1000;
          return dateSeconds <= seconds ? val : null;
        },
        firstLetterUpperCase,
    }
}
</script>
